import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, withKeys as _withKeys, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "plan-content mb-30" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"plan-details\"><div class=\"plan-general-details h-100 gap-10\"><h4>IATSE National Benefits Fund Office </h4><div class=\"plan-general-container\"><div class=\"plan-general-detail-container\"><div class=\"plan-general-detail-line\"><h4>417 Fifth Avenue</h4><h4>3rd Floor</h4><h4>New York, NY 10016-2204</h4></div></div></div></div><div class=\"plan-general-details h-100 gap-10 w-100\"><h4>Main Numbers</h4><div class=\"plan-general-container\"><div class=\"plan-general-detail-container gap-20\"><div class=\"plan-general-detail-line\"><h5>Main Number </h5><h4>212-580-9092</h4></div><div class=\"plan-general-detail-line\"><h5>Toll Free Number </h5><h4>800-456-3863 </h4></div><div class=\"plan-general-detail-line\"><h5>Fax Number</h5><h4>212-787-3607 </h4></div></div></div></div><div class=\"plan-general-details h-100 gap-10\"><h4>Email Addresses</h4><div class=\"plan-general-container\"><div class=\"plan-general-detail-container flex-column w-100 align-items-start\"><div class=\"plan-general-detail-line flex-row align-items-center gap-10\"><h5>Participant Services</h5><h4>psc@iatsenbf.org </h4></div><div class=\"plan-general-detail-line flex-row align-items-center gap-10\"><h5>Webmaster </h5><h4>webadmin@iatsenbf.org</h4></div><small>Email Webmaster for any website technical issues.</small></div></div></div></div>", 1)
const _hoisted_3 = { class: "w-100 inputs-wrapper mb-20 d-flex flex-wrap gap-20" }
const _hoisted_4 = { class: "d-flex flex-column align-items-end mt-20 ms-auto" }
const _hoisted_5 = {
  type: "submit",
  class: "btn btn-primary"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SelectComponent = _resolveComponent("SelectComponent")!
  const _component_TextInput = _resolveComponent("TextInput")!
  const _component_Textarea = _resolveComponent("Textarea")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    ($setup.userName)
      ? (_openBlock(), _createElementBlock("form", {
          key: 0,
          onSubmit: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => ($setup.handleSubmit && $setup.handleSubmit(...args)), ["prevent"])),
          onKeypress: _cache[7] || (_cache[7] = _withKeys(
//@ts-ignore
(...args) => ($setup.handleSubmit && $setup.handleSubmit(...args)), ["enter"])),
          class: "form update-address align-items-start mt-20",
          method: "post"
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_SelectComponent, {
              label: "Topic",
              selectedOption: $setup.formData.Topic,
              "onUpdate:selectedOption": _cache[0] || (_cache[0] = ($event: any) => (($setup.formData.Topic) = $event)),
              options: $setup.topics,
              singleArrow: true,
              error: $setup.errors?.Topic
            }, null, 8, ["selectedOption", "options", "error"]),
            _createVNode(_component_TextInput, {
              type: "text",
              label: "Full Name",
              placeholder: "Enter Full Name",
              max: 50,
              modelValue: $setup.formData.FullName,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.formData.FullName) = $event)),
              error: $setup.errors?.FullName,
              isRequired: true
            }, null, 8, ["modelValue", "error"]),
            _createVNode(_component_TextInput, {
              type: "email",
              label: "Email Address",
              placeholder: "Enter Email Address",
              max: 50,
              modelValue: $setup.formData.Email,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.formData.Email) = $event)),
              isRequired: true,
              error: $setup.errors?.Email
            }, null, 8, ["modelValue", "error"]),
            _createVNode(_component_TextInput, {
              type: "email",
              label: "Confirm Email Address",
              placeholder: "Enter Email Address Confirmation",
              max: 50,
              modelValue: $setup.formData.Email_confirmation,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.formData.Email_confirmation) = $event)),
              isRequired: true,
              error: $setup.errors?.Email_confirmation
            }, null, 8, ["modelValue", "error"]),
            _createVNode(_component_TextInput, {
              type: "text",
              name: "phone",
              label: "Phone Number",
              placeholder: "Enter Phone Number",
              max: 17,
              modelValue: $setup.formData.PhoneNumber,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.formData.PhoneNumber) = $event)),
              error: $setup.errors?.PhoneNumber,
              isRequired: true
            }, null, 8, ["modelValue", "error"]),
            _createVNode(_component_Textarea, {
              label: "Message",
              message: "Notes field accepts minimum 10 characters",
              modelValue: $setup.formData.Message,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.formData.Message) = $event)),
              max: 1000,
              error: $setup.errors?.Message,
              "is-required": true
            }, null, 8, ["modelValue", "error"]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("button", _hoisted_5, _toDisplayString($setup.loadingSubmit ? 'Submitting...' : 'Submit'), 1)
            ])
          ])
        ], 32))
      : _createCommentVNode("", true)
  ]))
}